export default __webpack_public_path__ + "static/media/menu_photo2.a99c5893.png";